import { type Ref, forwardRef } from "react";
import { TableVirtuoso, type TableVirtuosoHandle, type TableVirtuosoProps } from "react-virtuoso";
import { VirtuosoTable } from "./Table";
import { VirtuosoTableBody } from "./TableBody";
import { VirtuosoTableHead } from "./TableHead";
import { VirtuosoTableRow } from "./TableRow";
import { type ITableVirtualizedContext, TableVirtualizedProvider } from "./context";

export interface ITableVirtualizedProps<Data, Context>
  extends TableVirtuosoProps<Data, Context>,
    ITableVirtualizedContext {}

export const TableVirtualized = forwardRef(function TableVirtualized<Data, Context>(
  { slotProps, ...props }: ITableVirtualizedProps<Data, Context>,
  ref: Ref<TableVirtuosoHandle>
) {
  return (
    <TableVirtualizedProvider slotProps={slotProps}>
      <TableVirtuoso
        {...props}
        ref={ref}
        components={{
          ...props.components,
          // biome-ignore lint/style/useNamingConvention: Virtuoso props
          Table: VirtuosoTable,
          // biome-ignore lint/style/useNamingConvention: Virtuoso props
          TableHead: VirtuosoTableHead,
          // biome-ignore lint/style/useNamingConvention: Virtuoso props
          TableBody: VirtuosoTableBody,
          // biome-ignore lint/style/useNamingConvention: Virtuoso props
          TableRow: VirtuosoTableRow,
        }}
      />
    </TableVirtualizedProvider>
  );
});
